interface AutoCompleteOption<T> {
  text: string;
  value: T;
}

class AutoCompleteHelper<T> {

  private unicodeAccentsRe = /[\u0300-\u036f]/g;
  private options: Array<AutoCompleteOption<T>>;

  constructor(options: Array<AutoCompleteOption<T>>) {
    this.options = options.map(o => ({
      text: this.normalizeText(o.text),
      value: o.value
    }));
  }

  public search(text: string): T[] {
    const normalized = this.normalizeText(text);
    return this.options
      .filter(o => o.text.startsWith(normalized))
      .map(o => o.value);
  }

  private normalizeText(text: string): string {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(this.unicodeAccentsRe, '');
  }
}
export { AutoCompleteHelper, AutoCompleteOption };



// WEBPACK FOOTER //
// ./src/common/input/auto-complete-helper.ts